// extracted by mini-css-extract-plugin
module.exports = {"actions":"_1SI3d5","label":"_3IpnKl","switch":"_2qj8Rk"};